export const PLAYLIST_FERMA_MINUTI_DEFAULT = 5;

function readBool(value: any): boolean {
  if (value === true || value === 1 || value === '1' || value === 'true' || value === 'S' || value === 's') {
    return true;
  }
  return false;
}

function isMonitorOnline(record: any, offlineMinuti = 3): boolean {
  if (record?.online === true || record?.online === false) {
    return record.online;
  }
  const last = record?.last_daemon_at || record?.last_update;
  if (!last) {
    return false;
  }
  return Date.now() - new Date(last).getTime() < offlineMinuti * 60000;
}

function minutiDaUltimoSignage(record: any): number | null {
  const signage = record?.last_signage_at;
  if (!signage) {
    return null;
  }
  const d = new Date(signage);
  if (isNaN(d.getTime())) {
    return null;
  }
  return (Date.now() - d.getTime()) / 60000;
}

/** Monitor online in Play ma signage fermo da oltre soglia, oppure flag esplicito dal backend. */
export function isPlaylistBloccata(
  record: any,
  sogliaMinuti = PLAYLIST_FERMA_MINUTI_DEFAULT,
  offlineMinuti = 3
): boolean {
  if (!record) {
    return false;
  }

  const boolKeys = [
    'playlist_bloccata',
    'playlist_ferma',
    'playlist_stopped',
    'playlist_blocked',
    'playlistBloccata',
    'playlistFerma',
  ];
  for (const key of boolKeys) {
    if (readBool(record[key])) {
      return true;
    }
  }

  const statoPlaylist = String(
    record.stato_playlist || record.playlist_stato || record.playlist_status || ''
  ).toLowerCase();
  if (['bloccata', 'ferma', 'stopped', 'blocked', 'stuck', 'bloccato', 'fermo'].includes(statoPlaylist)) {
    return true;
  }

  const alertPlaylist = String(record.alert_playlist || record.playlist_alert || '').toLowerCase();
  if (alertPlaylist.includes('blocc') || alertPlaylist.includes('ferm') || alertPlaylist.includes('stop')) {
    return true;
  }

  if (!isMonitorOnline(record, offlineMinuti) || record.azione_corrente !== 'Play') {
    return false;
  }
  if (!record.playlist_id && !record.playlist_nome) {
    return false;
  }

  const gap = minutiDaUltimoSignage(record);
  return gap !== null && gap >= sogliaMinuti;
}

export function playlistBloccataMessaggio(record: any, sogliaMinuti: number): string {
  const nome = record.descrizione || record.nome || record.indirizzo_ip || 'Monitor';
  const playlist = record.playlist_nome || 'playlist';
  const gap = minutiDaUltimoSignage(record);
  if (gap !== null) {
    return (
      nome +
      ': playlist "' +
      playlist +
      '" ferma da oltre ' +
      Math.floor(gap) +
      ' min (soglia ' +
      sogliaMinuti +
      ' min)'
    );
  }
  return nome + ': playlist "' + playlist + '" segnalata come bloccata/ferma';
}
